import { http } from './http';
import { env } from '@/lib/env';
import {
  loadingContextPath, normalizeLoadingContext,
  type LoadingContext, type LoadingContextKind,
} from '@marcianus/shared/loading-client';

/**
 * Passos REAIS de arranque (GET /loading/context) — o que o ecrã de abertura
 * mostra por baixo do símbolo.
 *
 * Sem autenticação por construção: isto corre ANTES de haver sessão. E nunca
 * lança — um arranque que rebenta porque a sonda de arranque falhou seria o
 * pior negócio possível. Falhar aqui significa «sem passos», e o loader mostra
 * a legenda de sempre.
 */
export async function getLoadingContext(kind: LoadingContextKind = 'boot'): Promise<LoadingContext | null> {
  if (env.preview || env.mocksEnabled) return null;
  try {
    return normalizeLoadingContext(await http.get<unknown>(loadingContextPath(kind)));
  } catch {
    return null;
  }
}
